import React, { useContext, useState } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import Context from "../../../Context";
import SVGDocument2 from "../../Misc/SvgIcons/SVGDocument2";
import WorkdocTypedocList from "../Workdoc/WorkdocTypedocList";
import { getTypedocByKey } from "../Workdoc/typedoc";

export default function HeaderWorkdoc() {
  let [typedocListShow, setTypedocListShow] = useState(false);

  let isActive = useRouteMatch("/workdoc");

  let iconClass = "primary";
  let titleSuffix = "";

  const isPulse = false;
  const pulseRing = isPulse ? <span className="pulse-ring"></span> : "";

  if (isPulse) {
    iconClass = "info";
  }

  let templateDoc = Object.assign(getTypedocByKey("template"), {
    url: "/workdoc/add/any/",
    label: "Из шаблона",
    description: "Перейти к выбору шаблона нового документа",
  });

  return (
    <React.Fragment>
      {typedocListShow && (
        <WorkdocTypedocList
          documents={[templateDoc]}
          onHide={() => setTypedocListShow(false)}
        />
      )}
      <div
        className="topbar-item"
        onContextMenu={(e) => {
          e.preventDefault();
          setTypedocListShow(true);
        }}
      >
        <Link to="/workdoc/" title={`Рабочая документация ${titleSuffix}`}>
          <div
            className={`btn btn-icon btn-clean btn-dropdown btn-lg mr-1 pulse pulse-${iconClass} ${
              isActive ? "bg-light" : ""
            }`}
          >
            <span className={`svg-icon svg-icon-xl svg-icon-${iconClass}`}>
              <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <rect x="0" y="0" width="24" height="24" />
                  <path
                    d="M6,2 L18,2 C18.5522847,2 19,2.44771525 19,3 L19,12 C19,12.5522847 18.5522847,13 18,13 L6,13 C5.44771525,13 5,12.5522847 5,12 L5,3 C5,2.44771525 5.44771525,2 6,2 Z M7.5,5 C7.22385763,5 7,5.22385763 7,5.5 C7,5.77614237 7.22385763,6 7.5,6 L13.5,6 C13.7761424,6 14,5.77614237 14,5.5 C14,5.22385763 13.7761424,5 13.5,5 L7.5,5 Z M7.5,7 C7.22385763,7 7,7.22385763 7,7.5 C7,7.77614237 7.22385763,8 7.5,8 L10.5,8 C10.7761424,8 11,7.77614237 11,7.5 C11,7.22385763 10.7761424,7 10.5,7 L7.5,7 Z"
                    fill="#000000"
                    opacity="0.3"
                  />
                  <path
                    d="M3.79274528,6.57253826 L12,12.5 L20.2072547,6.57253826 C20.4311176,6.4108595 20.7436609,6.46126971 20.9053396,6.68513259 C20.9668779,6.77033951 21,6.87277228 21,6.97787787 L21,17 C21,18.1045695 20.1045695,19 19,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,6.97787787 C3,6.70173549 3.22385763,6.47787787 3.5,6.47787787 C3.60510559,6.47787787 3.70753836,6.51099993 3.79274528,6.57253826 Z"
                    fill="#000000"
                  />
                </g>
              </svg>
            </span>
            {pulseRing}
          </div>
        </Link>
      </div>
    </React.Fragment>
  );
}
